import { FaSearch, FaBullhorn, FaFileImage, FaPaw } from "react-icons/fa";

const Services = () => {
  const servicesData = [
    {
      id: 1,
      icon: <FaSearch className="text-[#DC5D00]" />,
      title: "Búsqueda Inteligente",
      description:
        "Encontrá tu mascota más rápido gracias a nuestro sistema de búsqueda cruzada.",
    },
    {
      id: 2,
      icon: <FaBullhorn className="text-[#DC5D00]" />,
      title: "Difusión Automática",
      description:
        "Todas las mascotas son publicadas en nuestras redes (Ig y facebook) automaticamente.",
    },
    {
      id: 3,
      icon: <FaFileImage className="text-[#DC5D00]" />,
      title: "Carteles Personalizados",
      description:
        "Cartel descargable con codigo QR y los datos de tu mascota, listo para imprimir o compartir.",
    },
    {
      id: 4,
      icon: <FaPaw className="text-[#DC5D00]" />,
      title: "Adopciones",
      description:
        "Publicá mascotas que necesitan un nuevo hogar o encontrá a tu próximo amigo de vida en nuestra red.",
    },
  ];

  return (
    <main className="bg-gray-100 min-h-screen flex flex-col items-center justify-center sm:px-2 py-32 nav:py-0">
      <div className="text-center mb-10">
        <h2 className="nav:text-4xl text-3xl font-extrabold font-main">Nuestros Servicios</h2>
        <p className="font-main text-md font-medium p-2">
          Estas son algunas de nuestras principales características y funciones!
        </p>
      </div>
      <div className="grid nav:grid-cols-2 grid-cols-1 gap-6">
        {servicesData.map((item) => (
          <div
            key={item.id}
            className="w-80 min-h-56 flex flex-col items-center justify-center rounded-lg bg-gray-200 p-6"
          >
            <div className="mb-4 text-4xl">{item.icon}</div>
            <h3 className="font-main font-bold text-xl text-center text-gray-800">
              {item.title}
            </h3>
            <p className="font-main font-medium text-sm text-center text-gray-600 mt-2">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </main>
  );
};

export default Services;
